export const getTitle = (priceInPence: number): string => {
  const pounds = Math.floor(priceInPence / 100)
  const pence = priceInPence % 100
  let paddedPence = '' + pence
  if(paddedPence.length < 2) paddedPence = '0' + paddedPence
  return `£${pounds}.${paddedPence}`
}